import React from 'react';
import { AccordionContext, AccordionItemContext } from './Context';
import {Collapse} from 'native-base';
import { useThemeProps } from 'native-base';
// import { useHasResponsiveProps } from '../../../hooks/useHasResponsiveProps';

const AccordionDetails = (
  { children, ...props },
  ref
) => {
  const { ...newProps } = useThemeProps('AccordionDetails', props);
  const { isOpen } = React.useContext(
    AccordionItemContext
  );
  const { AnimationProps } = React.useContext(
    AccordionContext
  );
  //TODO: refactor for responsive prop
  // if (useHasResponsiveProps(props)) {
  //   return null;
  // }
  return (
    <Collapse {...AnimationProps} {...newProps} isOpen={isOpen} ref={ref}>
      {children}
    </Collapse>
  );
};

export default React.memo(React.forwardRef(AccordionDetails));
